import { cloneDeep } from 'lodash';
import findResult, {
  assignIfExists,
  newName,
  nextCarouselItem,
} from '@/utils/resultsHelper';
import withDraft from '@/utils/draftHelper';
import { findWithUUID } from '@/utils/uuidHelper';
import newCohortQuery, { activeQuery, addUUIDsToCohortQuery } from './state';
import pruneCohortErrors, { assignEditCohortProps, findCohort } from '../../state/shared';
import actions from '../constants';

const addCohortQuery = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  assignEditCohortProps(item, true);

  const query = findWithUUID(item.queries, item.activeQueryUUID);
  const dictionary = query.dataset.dictionaries.find((d) => d.code === query.activeDictionaryCode);
  const name = newName('Cohort', item.queries.map((q) => q.name));
  const newQuery = newCohortQuery(query.dataset, [dictionary], name, item);
  item.activeQueryUUID = newQuery.uuid;
  item.queries.push(newQuery);
});

const cloneCohortQuery = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  assignEditCohortProps(item, true);

  const query = findWithUUID(item.queries, action.queryUUID);
  const newQuery = addUUIDsToCohortQuery(query, false, [], true);

  newQuery.name = newName('Cohort', item.queries.map((q) => q.name));
  newQuery.visualisations = cloneDeep(query.visualisations);
  item.activeQueryUUID = newQuery.uuid;
  item.queries.push(newQuery);
});

const removeCohortQuery = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  assignEditCohortProps(item, true);
  item.activeQueryUUID = nextCarouselItem(item.queries, action.queryUUID, 'uuid');
  item.queries = item.queries.filter((r) => (r.uuid !== action.queryUUID));
});

const showRenameQuery = withDraft((draft, action) => {
  const item = findCohort(draft, action);
  const query = findWithUUID(item.queries, action.queryUUID);

  draft.activeQuery.open = true;
  draft.activeQuery.code = action.code;
  draft.activeQuery.category = action.category;
  draft.activeQuery.uuid = query.uuid;
  draft.activeQuery.name = query.name;
  draft.activeQuery.description = query.description;
});

const hideRenameQuery = withDraft((draft, action) => {
  if (!action.cancel) {
    const cohort = findResult(draft.cohorts, draft.activeQuery.category, draft.activeQuery.code);
    assignEditCohortProps(cohort, true);
    const query = findWithUUID(cohort.queries, draft.activeQuery.uuid);
    query.name = draft.activeQuery.name;
    query.description = draft.activeQuery.description;
  }
  draft.activeQuery = activeQuery();
});

const updateActiveQueryProperties = withDraft((draft, action) => {
  assignIfExists(draft.activeQuery, action.properties);
  draft.activeQuery.saveErrors = pruneCohortErrors(draft.activeQuery.saveErrors, action);
});

export default {
  [actions.ADD_COHORT_QUERY]: addCohortQuery,
  [actions.CLONE_COHORT_QUERY]: cloneCohortQuery,
  [actions.HIDE_RENAME_QUERY]: hideRenameQuery,
  [actions.REMOVE_COHORT_QUERY]: removeCohortQuery,
  [actions.SHOW_RENAME_QUERY]: showRenameQuery,
  [actions.UPDATE_ACTIVE_QUERY_PROPERTIES]: updateActiveQueryProperties,
};
